import { find, includes } from 'lodash/collection'
import { Perimeter } from 'vue-kindergarten'
import { checkPermission, minimalLevel, maximalLevel } from '@argon/iam/utils'
import { exactLevel } from '../utils'

export default class BasePerimeter extends Perimeter {
  isAuthenticated() {
    // child is the store itself. This gives us access to getters
    // if you return true here all authenticated routes will be accessible,
    return this.child && this.child.getters['auth/authenticated']
  }

  isAdmin() {
    let policies = this.child.getters['me/policies']
    // it would be saner to use the refname instead of attributes to
    // find what we're looking for, ie: { refname: 'admin' }
    let hasAdminPolicy = find(policies, {
      action: '*',
      scope: '*',
      subset: 'all'
    })
    return this.child && hasAdminPolicy
  }

  hasPermission(permissionString) {
    let policies = this.child.getters['me/policies']
    return this.child && checkPermission(policies, permissionString)
  }

  hasAction(entity, string) {
    return entity && entity.actions ? includes(entity.actions, string) || includes(entity.actions, '*') : false
  }

  isLevel(organization, level) {
    let claims = this.child.getters['me/claims']
    return this.child && organization && exactLevel(organization.id, claims, level)
  }
  isLevelOrAbove(organization, level) {
    let claims = this.child.getters['me/claims']
    return this.child && organization && minimalLevel(organization.id, claims, level)
  }

  isLevelOrBelow(organization, level) {
    let claims = this.child.getters['me/claims']
    return this.child && organization && maximalLevel(organization.id, claims, level)
  }
}
